import { render } from "./employeeProfile.vue?vue&type=template&id=0846974e&ts=true"
import script from "./employeeProfile.vue?vue&type=script&lang=ts"
export * from "./employeeProfile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__